import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import * as User from '../helpers/User';

const $= window.$;

class ChangePassword extends Component {
	constructor(props) {
		super(props);
        this.state={
           txtOldPassword : '',
           txtNewPassword: '',
           txtConfirmPassword : ''


        };
       this.onSubmit = this.onSubmit.bind(this);
       this.handleChange = this.handleChange.bind(this);
       this.clearForm = this.clearForm.bind(this);
	}

	clearForm(){

		var old_pwd = $("#txtOldPassword").val("");
		var new_pwd = $("#txtNewPassword").val("");
		var confirm_pwd = $("#txtConfirmPassword").val("");

		this.setState({
		   txtOldPassword : '',
           txtNewPassword: '',
           txtConfirmPassword : ''
		})
	}


	handleChange(e){
		this.setState({
			[e.target.name] : e.target.value
		})
	}

   onSubmit(e){
   		Common.reactLoader("show", "Please wait...");
   		let lr_id = Common.getUserData("id", true);
   		let username = Common.getUserData('primaryEmail', true);

   		fetch(Config.domainUrl +"user/change-password", {
	        method: "POST",
	        

	       headers: {
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
                'Authorization':'Bearer ' +Common.getTokenData()
	          },
	        body: JSON.stringify({
                    old_pwd:this.state.txtOldPassword,
                    new_pwd:this.state.txtNewPassword,
                    confirm_pwd:this.state.txtConfirmPassword,
			        learner_id:lr_id,
			        username : username
                  })
	       }).then((response) => response.json()).then((responseJson) => {
	       	 	Common.reactLoader("hide");
	       	 	//alert(JSON.stringify(responseJson));
	       		 if (responseJson.status == 0) {
			        Common.message(responseJson.message, responseJson.errors, "error");
			      } else {
			      	this.clearForm();
			        Common.message("", responseJson.message , "success");
			      }
	       });
   }

   maskunmask(id){
	if($('#'+id).attr('type') == 'password'){
		$("#"+id).attr('type','text');
		$("."+id+".eye_icon").removeClass('unmask');
	}else{
		$("#"+id).attr('type','password');
		
		$("."+id+".eye_icon").addClass('unmask');
	}
}

    componentDidMount() {
       


      

			// Common.showSmallLeftMenu();
    }




		render() {
			
			return (
			
				<div>
					<span className="add-observer">Password can contain English alphabet and numerals, but not special characters. Please note that the password is CaSE-sensitive.</span>
					<div className="tabgrey">
					    <div className="new-observer">
					        <div className="newobserver-left change-password">
					        	<form id="change_password_form" name="change_password_form" method="post" >
									<input type="hidden" name="chkoldpass" id="chkoldpass" value="" />			
						            <ul>
						                <div>
						                	<li className="label"><label>Old Password <span className="redstar">*</span> </label></li>
						                	<li style={{position: 'relative',width: '23%'}}>
						                		<input type="password" id="txtOldPassword" name="txtOldPassword" maxLength="30" className="txtbox"  onChange={(e)=>this.handleChange(e)} />
												<span style={{top: '6px'}} className="txtOldPassword eye_icon unmask" onClick={() => this.maskunmask('txtOldPassword')}></span>
							                </li>
						                </div>
						               
						                <div>
							                <li className="label"><label>New Password <span className="redstar">*</span> </label></li>
							                <li style={{position: 'relative',width: '23%'}}><input type="password" id="txtNewPassword" name="txtNewPassword"  maxLength="30" className="txtbox" onChange={(e)=>this.handleChange(e)} /><br />
												{/* <span className="min-char">Minimum of 6 characters in length. Use only (a-z, A-Z, 0-9)</span> */}
												<span style={{top: '6px'}} className="txtNewPassword eye_icon unmask" onClick={() => this.maskunmask('txtNewPassword')}></span>
												<span className="min-char" style={{color: '#f3523e'}}>Minimum of 6 characters in length.</span>
												<span className="min-char" style={{color: '#f3523e'}}>Password must be alpha numeric.</span>
												<span className="min-char" style={{color: '#f3523e'}}>It should not case sensitive.</span>
								            </li>                                                                    
								        </div>
						                
						                <div>
							                <li className="label"><label>Confirm New Password  <span className="redstar">*</span></label></li>
							                <li  style={{position: 'relative',width: '23%'}}>
							                	<input type="password" id="txtConfirmPassword" name="txtConfirmPassword"  maxLength="30" className="txtbox" onChange={(e)=>this.handleChange(e)}/><br />
												<span style={{top: '6px'}} className="txtConfirmPassword eye_icon unmask" onClick={() => this.maskunmask('txtConfirmPassword')}></span>
							                	 {/* <span className="min-char">Minimum of 6 characters in length. Use only (a-z, A-Z, 0-9)</span> */}
												<span className="min-char" style={{color: '#f3523e'}}>Minimum of 6 characters in length.</span>
												<span className="min-char" style={{color: '#f3523e'}}>Password must be alpha numeric.</span>
												<span className="min-char" style={{color: '#f3523e'}}>It should not case sensitive.</span>
							                </li>
						                </div>

						                <div>
							                <li className="label-required"><span className="redstar">*</span> 
							                	<label>Required fields </label>
							                </li>
							                <li><input type="button" value="Change Password" name="submit" className="password" alt="Change Password" title="Change Password" onClick={(e)=>this.onSubmit(e)}/></li>
						                </div>
						            </ul>
					        	</form>
					        </div>                                                            
					    </div>
					</div>
				</div>
				
			
			);
		}
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/my_profile/ChangePassword.js